import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from "vue";
import { VForm, VRow, VCol } from "vuetify/lib";
import { DateTime } from "luxon";
import { ShiftPattern } from "@/models/transaction/ShiftPattern";
import { PetitionShiftPatternSearchRequest } from "@/models/petition/PetitionRequest";
import { ShiftFlowDat } from "@/models/transaction/ShiftFlowDat";
import { PetitionShiftSearch } from "@/models/petition/PetitionResponse";
import { InputRules } from "@/rules";
import BeforeAfterList from "@/components/list/BeforeAfterList.vue";
import { EnumWorkClassification } from "@/models/enum/Enum";
import { $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { $alert } from "@/plugins/alert/alert";

interface VForm extends Vue {
  reset(): void;
  resetValidation(): void;
  validate(): boolean;
}

type Props = {
  date: DateTime;
  shift?: PetitionShiftSearch;
  affiliationId: number;
  employeeId: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeShiftApplication',
  props: {
    date: null,
    shift: null,
    affiliationId: null,
    employeeId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  date: DateTime;
  shift?: PetitionShiftSearch;
  affiliationId: number;
  employeeId: number;
};

const beforeHeader = [
  { text: "シフト名： ", value: "preShiftpatternNm" },
  { text: "シフト開始時間： ", value: "preStartTime" },
  { text: "シフト終了時間： ", value: "preEndTime" },
  { text: "シフト総休憩時間： ", value: "preBreakTime" },
  { text: "シフト早朝休憩時間： ", value: "preMorningBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "preMidnightBreakTime" }
] as const;

const afterHeader = [
  { text: "シフト名： ", value: "afterShiftpatternNm" },
  { text: "シフト開始時間： ", value: "afterStartTime" },
  { text: "シフト終了時間： ", value: "afterEndTime" },
  { text: "シフト総休憩時間： ", value: "afterBreakTime" },
  { text: "シフト早朝休憩時間： ", value: "afterMorningBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "afterMidnightBreakTime" }
] as const;

const sqlToFormatTime = (time: string) => {
  const date = DateTime.fromISO(time);
  return date.isValid ? date.toFormat("HH:mm") : null;
};



const form = ref(
  new ShiftFlowDat({
    recordId: 0,
    requestDate: DateTime.local().toISO(),
    date: props.date.toISO(),
    employeeId: props.employeeId,
    affiliationId: props.affiliationId,
    shiftId: props.shift?.shiftId,
    preShiftpatternId: props.shift?.shiftPatternId,
    preShiftpatternNm: props.shift?.shiftPatternName,
    preStartTime: props.shift?.shiftPatternStartTime,
    preEndTime: props.shift?.shiftPatternEndTime,
    preMorningBreakTime: props.shift?.shiftPatternMorningBreakTime,
    preBreakTime: props.shift?.shiftPatternBreakTime,
    preMidnightBreakTime: props.shift?.shiftPatternMidnightBreakTime
  })
);
const publicHoliday = new ShiftPattern({
  shiftPatternId: EnumWorkClassification.OFFICIAL_HOLIDAY,
  affiliationId: props.affiliationId,
  shiftPatternName: "公休",
  abbreviation: "",
  startTime: "",
  endTime: "",
  breakTime: "",
  morningBreakTime: "",
  midnightBreakTime: "",
  daytimeActiveHour: ""
});

const shiftPattern = ref<ShiftPattern[]>([]);
const selectShift = ref<ShiftPattern>();
const vform = ref<VForm>();
const newShiftPattern = computed(() => [...shiftPattern.value]);

watch(selectShift, (newValue?: ShiftPattern) => {
  if (newValue) {
    const value = form.value;
    value.afterShiftpatternId = newValue.shiftPatternId;
    value.afterShiftpatternNm = newValue.shiftPatternName;
    value.afterStartTime = sqlToFormatTime(newValue.startTime);
    value.afterEndTime = sqlToFormatTime(newValue.endTime);
    value.afterBreakTime = sqlToFormatTime(newValue.breakTime);
    value.afterMorningBreakTime = sqlToFormatTime(newValue.morningBreakTime);
    value.afterMidnightBreakTime = sqlToFormatTime(newValue.midnightBreakTime);
  }
});

const getShiftPattern = async () => {
  const request = new PetitionShiftPatternSearchRequest({
    affiliationId: props.affiliationId
  });
  const result = await $post<ShiftPattern[]>(
    Paths.petition.search.shiftPattern,
    request
  );
  if (result) {
    result.push(publicHoliday);
    shiftPattern.value = result.filter(
      e => e.shiftPatternId !== props.shift?.shiftPatternId
    );
  }
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", "入力に誤りがあります。\n入力内容を確認してください。");
    return;
  }
  const result = await $post(Paths.petition.insert.shift, form.value);
  if (result) {
    $alert("success", "申請に成功しました。");
    return true;
  } else {
    $alert("error", "申請に失敗しました。");
    return false;
  }
};

onMounted(async () => await getShiftPattern());

expose({ onSubmit });

return { __sfc: true,beforeHeader, afterHeader, sqlToFormatTime, props, form, publicHoliday, shiftPattern, selectShift, vform, newShiftPattern, getShiftPattern, onSubmit, VForm, VRow, VCol, InputRules, BeforeAfterList }
}

})